import Axios, { AxiosError } from "axios";
import messages from "../i18n/messages";

export const OPERATION_CANCELED = "OPERATION_CANCELED";

export const handleAxiosError = (error: any): string => {
  if (Axios.isCancel(error)) {
    return OPERATION_CANCELED;
  }

  const axiosError = error as AxiosError;
  if (!axiosError || !axiosError.isAxiosError) {
    console.error("An internal error has occurred", error);
    return messages.INTERNAL_ERROR;
  }

  if (axiosError.response) {
    // The request was made and the server responded with an error status code
    console.error(
      `The server returned HTTP status code ${axiosError.response.status} - ${axiosError.response.statusText}`,
      axiosError.response.data
    );

    if ((axiosError.response.data as any)?.error?.code) {
      const error = (axiosError.response.data as any)?.error;
      if (error.details) {
        // Details object might be a serialized object, try to parse it if it fails it's just a string
        let detailsObject;
        try {
          detailsObject = JSON.parse(error.details);
        } catch {
          detailsObject = error.details;
        }

        console.error(`Received more details on ${error.code}:`, detailsObject);
      }
      return `messages.${error.code}`;
    }

    if (axiosError.response.status === 400) {
      return messages.BAD_REQUEST;
    }

    return messages.SERVER_ERROR;
  }

  if (axiosError.request) {
    // The request was made but no response has been received
    console.error(
      "The request was made but no response has been received",
      axiosError.request
    );
    return messages.NO_RESPONSE;
  }

  // We were unable to send the request at all
  console.error("Error setting up the request", axiosError.message);
  return messages.INTERNAL_ERROR;
};
